export default {
  buildingNumber: 'Civic number',
  street: 'Street',
  subBuilding: 'Apartment / office (optional)',
  postalBox: 'P.O. Box number / rural route no. (optional)',
  ruralRoute: 'Rural Route No.',
  place: 'Place (optional)',
  city: 'City',
  country: 'Country',
  province: 'Province',
  state: 'State',
  postalCode: 'Postal Code',
  zipCode: 'ZIP Code',
  moreInfo: 'Place, postal box or rural route',
};
